import map from 'lodash/map';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import upperFirst from 'lodash/upperFirst';

/**
 * @visibleName Control Container
 */

const ControlContainer = ({
  control,
  'data-aid': dataAid,
  description,
  error,
  label,
  success,
  tooltip,
  ...otherProps
}) => (
  <StyledControlContainer {...otherProps}>
    {
      <ControlLabelAndTooltipWrapper>
        {label && <ControlLabel data-aid={`${dataAid}-label`}>{label}</ControlLabel>}
        {tooltip && <ControlTooltip data-aid={`${dataAid}-tooltip`}>{tooltip}</ControlTooltip>}
      </ControlLabelAndTooltipWrapper>
    }
    {description && <ControlDescription data-aid={`${dataAid}-description`}>{description}</ControlDescription>}
    <ControlWrapper error={error}>{control}</ControlWrapper>
    {error && (
      <ErrorLabel className={suffixClassName(otherProps.className, 'Error')} data-aid={`${dataAid}-error`}>
        {upperFirst(error)}
      </ErrorLabel>
    )}
    {success && <SuccessLabel data-aid={`${dataAid}-success`}>{upperFirst(success)}</SuccessLabel>}
  </StyledControlContainer>
);

ControlContainer.propTypes = {
  control: PropTypes.element,
  'data-aid': PropTypes.string,
  description: PropTypes.any,
  error: PropTypes.string,
  expand: PropTypes.bool,
  label: PropTypes.any,
  tooltip: PropTypes.any,
};

ControlContainer.defaultProps = {
  expand: true,
};

function suffixClassName(className, suffix) {
  return map((className || '').split(' '), cn => `${cn}${suffix}`).join(' ');
}

const StyledControlContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${p => (p.expand ? 'flex: 1 1 auto' : '')};
  ${p => (p.preventContentFromOverflow ? 'min-width: 0' : '')};
`;

export const ControlWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 0;
  min-height: 36px;
`;

export const ControlLabel = styled.label`
  align-self: flex-start;
  font-weight: bolder;
  margin-bottom: ${p => p.theme.spacing.stackSmall};
  min-height: 18px;
`;

const ControlTooltip = styled.div`
  align-self: flex-end;
  margin-bottom: ${p => p.theme.spacing.stackSmall};
  min-height: 18px;
`;

export const ControlLabelAndTooltipWrapper = styled.div`
  display: flex;
  font-size: ${p => p.theme.fontSize.base};
`;

export const ControlDescription = styled.div`
  align-self: flex-start;
  font-size: ${p => p.theme.fontSize.base};
  color: ${p => p.theme.colors.gray700};
  line-height: 1.6;
  margin-bottom: ${p => p.theme.spacing.stackSmall};
  min-height: 18px;
`;

export const ErrorLabel = styled.div`
  color: ${p => p.theme.colors.red400};
`;
export const SuccessLabel = styled.div`
  color: ${p => p.theme.colors.green400};
`;

export default ControlContainer;
